import type {InlineVideo} from '@helios/shared/types/inline-video'

export type Video = {
    url?: string | null
}

type Sources = {
    webm?: Video
    mp4?: Video
}

export const getVideoSources = (sources: Sources): InlineVideo | undefined => {
    const webm = sources.webm?.url
    const mp4 = sources.mp4?.url

    if (webm && mp4) {
        return {
            webm,
            mp4,
        }
    }

    if (webm) {
        return {
            webm,
        }
    }

    if (mp4) {
        return {
            mp4,
        }
    }

    return undefined
}
